import { clearAuth, getToken, getUser, setGunsToken, setToken, setUser } from '@/config/auth'

const state = {
  token: getToken(),
  user: getUser()
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token || ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  CLEAR_AUTH (state) {
    state.token = ''
    state.user = null
  }
}

const actions = {
  login ({ commit }, { token, user, remember, gunsToken }) {
    setToken(token, remember !== false)
    if (gunsToken) {
      setGunsToken(gunsToken, remember !== false)
    }
    setUser(user)
    commit('SET_TOKEN', token)
    commit('SET_USER', user)
  },
  logout ({ commit }) {
    clearAuth()
    commit('CLEAR_AUTH')
  }
}

const getters = {
  isLoggedIn: state => !!state.token
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
